import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BackendObjectRef } from '../lib/backend-integration.service';
import { State } from '../lib/state.model';

import { WorkflowEditorStore } from '../lib/workflow-editor.store';
import { WorkflowStateFormComponent, WorkflowStateFormOptions, WorkflowStateFormResult } from './state-form.component';

@Component({
    selector: 'eas-workflow-states-editor',
    templateUrl: './states-editor.component.html',
    styleUrls: ['./states-editor.component.css'],
    standalone: false
})
export class WorkflowStatesEditorComponent implements OnInit, OnDestroy {
  public states: State[];
  public availableRoles: BackendObjectRef[];

  private destroyed$: Subject<void> = new Subject<void>();

  private dialogService: MatDialog;

  private dialogRef?:
    MatDialogRef<WorkflowStateFormComponent, WorkflowStateFormResult>;

  private workflowStore: WorkflowEditorStore;

  constructor(dialog: MatDialog, store: WorkflowEditorStore) {
    this.dialogService = dialog;
    this.workflowStore = store;
    this.states = this.workflowStore.workflow?.states ?? [];
    this.availableRoles = this.workflowStore.availableRoles;
  }

  ngOnInit(): void {
    this.workflowStore.workflow$
                      .pipe(takeUntil(this.destroyed$))
                      .subscribe(workflow => {
                        this.states = workflow?.states ?? [];
                      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  //
  // Actions
  //

  public onEdit(id: string): void {
    if (this.workflowStore.workflow === undefined) { return; }
    const state = this.workflowStore.workflow.stateByID(id);
    if (!state) { return; }

    this.presentFormFieldFormDialog(state, (result) => {
      if (result === undefined) { return; }

      if (typeof result === 'string') {
        // this.workflowStore.deleteState(result);
        return;
      }

      const update = new State(state.id, state.name, false, result.canDeleteRoles);
      this.workflowStore.updateState(update);
    });
  }

  //
  // Private stuff
  //

  private presentFormFieldFormDialog(object: State,
                            afterClosed?: (result: WorkflowStateFormResult) => void): void {
    if (this.dialogRef) { return; }

    const options: MatDialogConfig<WorkflowStateFormOptions> = {
      minWidth: '60vw',
      minHeight: '80vh',
      data: {
        item: object,
        availableRoles: this.workflowStore.createRolesSelectData()
      }
    };

    this.dialogRef =
      this.dialogService.open<WorkflowStateFormComponent,
                              WorkflowStateFormOptions,
                              WorkflowStateFormResult>(WorkflowStateFormComponent, options);
    this.dialogRef.afterClosed().subscribe(result => {
      this.dialogRef = undefined;
      if (afterClosed && result) { afterClosed(result); }
    });
  }
}
